import ClickOutside from '@scripts/modules/ClickOutside'

new ClickOutside('.ui-consult')
